export type UpdateType = 'release' | 'milestone' | 'team';

export type UpdateItem = {
  id: string;
  date: string;
  title: string;
  description: string;
  emoji: string;
  type: UpdateType;
  summary: string;
  highlight?: boolean;
};

export const updates: UpdateItem[] = [
  {
    id: 'team-recruitment',
    date: '01.03.2026',
    title: 'Открыли набор в команду',
    description: 'Собираем людей, которым интересно строить Celestix вместе: требуются Java-разработчики, React-разработчики и UX/UI-дизайнеры.',
    emoji: '🛠️',
    type: 'team',
    summary: 'Формируем основную команду разработки и ищем людей на ключевые роли.',
    highlight: true,
  },
  {
    id: 'survey-created',
    date: '28.02.2026',
    title: 'Создан опрос для студентов',
    description: 'Подготовили опрос, чтобы понять потребность в сайте, интерес студентов к проекту и какие сценарии для них наиболее важны.',
    emoji: '📋',
    type: 'milestone',
    summary: 'Запустили сбор обратной связи, чтобы проверить потребность в сайте и ожидания студентов.',
    highlight: true,
  },
  {
    id: 'beta-visiting-page',
    date: '12.02.2026',
    title: 'Первая бета визитки готова',
    description: 'Уже вовсю работаем над проектом и исправляем смешные баги. Команда пыхтит на полную!',
    emoji: '🚀',
    type: 'release',
    summary: 'Запустили первую beta-версию визитки и оформили публичную точку входа в проект.',
    highlight: true,
  },
  {
    id: 'star-is-born',
    date: '08.02.2026',
    title: 'Рождение звезды',
    description: 'Именно в этот день наша звездочка Celestix начала существовать не только в мыслях! 🎉',
    emoji: '⭐',
    type: 'milestone',
    summary: 'Зафиксировали старт проекта и оформили первую концепцию Celestix.',
    highlight: true,
  },
];

export const latestUpdate = updates[0];
export const highlightedUpdates = updates.filter((update) => update.highlight).slice(0, 3);

export const developmentSnapshot = {
  stage: 'Ранняя бета',
  focus: 'Развитие платформы, упаковка ключевых сценариев и сбор сильной команды.',
  recruitmentRoles: ['Java', 'React', 'UX/UI'],
  bullets: [
    'Собираем понятную публичную структуру продукта и страниц проекта.',
    'Показываем прогресс через changelog, чтобы развитие было прозрачным.',
    'Готовим базу для следующих продуктовых и технических итераций.',
  ],
};
